module.exports = __webpack_public_path__ + "pastorius-logo.png?01e8bf098a2d3b14bc84585ea55a027d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pastorius-logo.png
// module id = 39
// module chunks = 0